import { IServerResponse } from 'Utilities/ClientResponseUtility';

export const GetResultData = (response: IServerResponse, activityDataType: string): any[] => {
  let result = response.Data === null ? [] : FormatRequestData(response, activityDataType);
  return result;
};

const FormatRequestData = (result: any, tableName: any): any[] => {
  let data: any = [];
  let tableType = '';
  switch (tableName.toLowerCase()) {
    case 'billing':
      tableType = 'BillingData';
      break;
    case 'claims':
      tableType = 'Claims';
      break;
    case 'policy':
      tableType = 'Policies';
      break;
  }
  data = result.Data[tableType];

  //response bodies with tab characters in certain spots throw everything off
  if (!data && result?.Data && typeof result.Data == 'string')
    data = JSON.parse(result.Data.replaceAll('\t', ' '))[tableType];

  data.sort((a: any, b: any) => {
    let adate: any = new Date(b.ActivityDate);
    let bdate: any = new Date(a.ActivityDate);
    return adate - bdate;
  });
  for (var i = 0; i < data.length; i++) {
    data[i].Id = i;
    data[i].InsuredName = data[i].InsuredName.toUpperCase().replace(/\s+/g, ' ').trim();
    data[i].AgencyName = data[i].AgencyName.toLowerCase()
      .split(/[ ,]+/)
      .map((s: any) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ');
  }
  return data;
};

export const FilterDates = (results: any[], activityDataType: string): any[] => {
  //if table is policy or claims only allow last 10 days. if billing show only last 45 days.
  let filteredResults = [];
  let dateRange = activityDataType.toLowerCase() === 'billing' ? 45 : 11;
  let item = null;
  let msToDay = 1000 * 60 * 60 * 24;
  let to = new Date(); //today
  let day = new Date();
  let from = new Date(to.getTime() - dateRange * msToDay);

  for (let i = 0; i < results.length; i++) {
    item = results[i];
    day = new Date(item.ActivityDate);
    if (day >= from) {
      //allow for recent activities that have an upcoming activity date in the future
      filteredResults.push(item);
    }
  }
  return filteredResults;
};
